import { gql } from '@apollo/client';


export const CREATE_CHANNEL_INTENT = gql`
  mutation create_channel_intent($data: CreateChannelIntentInputType!) {
    create_channel_intent(data: $data) {
      hasError
      message
      data
    }
  }
`;